import {
  Box,
  Dialog,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { NewCampaignProvider } from "contexts/NewCampaign";

import CampaignBuilder from ".";
import { CampaignStep } from "./schema";
import styles from "./styles";

interface Props {
  open: boolean;
  onClose: () => void;
  // Open an already-created campaign and jump to a step (e.g. local pitching →
  // "Write Emails"). Omit both to start a fresh campaign.
  campaignId?: number;
  initialStep?: CampaignStep;
}

export default function CampaignBuilderDialog({
  open,
  onClose,
  campaignId,
  initialStep,
}: Props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={() => onClose()}
      fullWidth
      maxWidth="lg"
      fullScreen={fullScreen}
      PaperProps={{ sx: styles.dialogPaper }}
    >
      <IconButton
        onClick={() => onClose()}
        sx={styles.dialogClose}
        aria-label="Close"
      >
        <Box component="i" className="fa-regular fa-xmark" />
      </IconButton>
      {/* No router here — the builder tracks its step state internally in dialog
          mode (see the `onExit` prop), so it runs under the app's router without
          changing the page URL. */}
      <NewCampaignProvider>
        <CampaignBuilder
          onExit={() => onClose()}
          initialCampaignId={campaignId}
          initialStep={initialStep}
        />
      </NewCampaignProvider>
    </Dialog>
  );
}
